import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import { IbInsuranceAllianzDatalayerUtilsService } from './app/shared/ib-insurance-allianz-datalayer-utils.service';
import { AJSDatalayerHelperProvider } from './app/shared/upgraded/ib-datalayer-helper-bridge.service';
import { AJSCommonsUtilServiceProvider } from './app/shared/upgraded/ib-commons-utils-bridge.service';
import { AJSDigitalDataServiceProvider } from './app/shared/upgraded/ib-digital-data-bridge.service';

@NgModule({
    declarations: [],
    exports: [],
    imports: [
        CommonModule,
        TranslateModule
    ],
    providers: [
        IbInsuranceAllianzDatalayerUtilsService,
        AJSDatalayerHelperProvider,
        AJSCommonsUtilServiceProvider,
        AJSDigitalDataServiceProvider
    ]
})
export class IbAncillariesAppModule { }

